import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import AreaList01Actions, { AreaList01Types } from '../Stores/AreaList01/Actions';

const getAppStore = state => state.app;

export function* areaList01FetchAreaList01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(AreaList01Actions.areaList01FetchAreaList01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `area/indexProcess/AREA_LIST_01`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        AreaList01Actions.areaList01FetchAreaList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AreaList01Actions.areaList01FetchAreaList01Loading(false));
  }
}

export function* areaList01GoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/areaDetail/update/${resId}`));
}

export function* areaList01NewResource() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/areaDetail/create/${app.curSiteFlowId}`));
}

export const saga = [
  takeLatest(AreaList01Types.AREA_LIST01_GO_TO_RESOURCE, areaList01GoToResource),
  takeLatest(AreaList01Types.AREA_LIST01_FETCH_AREA_LIST01, areaList01FetchAreaList01),
  takeLatest(AreaList01Types.AREA_LIST01_NEW_RESOURCE, areaList01NewResource)
];
